import React from 'react';
import PropTypes from 'prop-types';
import './LoginPanel.scss';
import { Link } from 'react-router-dom';
import getSetCookie from './../../../cookie';
import AuthModal from 'desktop/components/AuthModal/AuthModalLoadable';


const LoginPanel = props => {
    const { section, loginStatus, userInfo, loginLoader, openLoginTab, openSignUpTab, registerActions, commonCallsActionCreators, cartActions } = props;
    return (
        <div className="">
            <div onClick={() => { if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.headerClick(section, 'LOGIN', loginStatus); }}>
                {loginLoader ? <p className="saving"><span>.</span><span>.</span><span>.</span></p> :
                    <div>
                        {
                            loginStatus && userInfo !== null ?
                                <div className="login-panel">
                                    {userInfo.result.firstName ? <div>{userInfo.result.firstName}<i className="fa fa-caret-down"></i></div> : <span>Specsy</span>}
                                    <div>

                                        <div className="navbar-dropdown-menu">
                                            {loginStatus === true
                                                ? <div>
                                                    <Link to="/customer/account/" className="dropdown-list">My Orders</Link>
                                                    <Link to="/customer/prescriptions/" className="dropdown-list">My Prescription</Link>
                                                    <Link to="/customer/account/storecredit/" className="dropdown-list">My Store Credit</Link>
                                                    <Link to="/customer/ditto-profile/" className="dropdown-list">My Dittos</Link>
                                                    <Link to="/customer/account/edit/" className="dropdown-list">Account Information</Link>
                                                    <a
                                                        className="dropdown-list"
                                                        onClick={() => {
                                                            registerActions.logoutUser();
                                                            commonCallsActionCreators.logoutUser();
                                                            cartActions.logoutUser();
                                                            sessionStorage.removeItem('orderActivePage');
                                                            document.location.href = '/';
                                                            window?.Freshbots?.resetCustomer(true);
                                                        }}
                                                    >Logout</a>
                                                </div> : ''}

                                        </div>
                                    </div>
                                </div> :
                                <div className="user-name" onMouseOver={() => { AuthModal.preload(); }} onFocus={() => { AuthModal.preload(); }}>
                                    <span onClick={openLoginTab} className="cursor-pointer">Sign In &</span> <span onClick={openSignUpTab} className="cursor-pointer">Sign Up</span>
                                </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

LoginPanel.propTypes = { section: PropTypes.any, loginStatus: PropTypes.bool, userInfo: PropTypes.object, loginLoader: PropTypes.bool, openLoginTab: PropTypes.func, openSignUpTab: PropTypes.func };

export default LoginPanel;
